<template>
  <div class="row">
    <div v-if="$store.state.inviteApplicants" key="Invite" class="col-md-12 card" v-loading="inviting"
      element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Invite Applicant</h4>
      </div>
      <div class="card-content row form-horizontal">
        <dynamic-input name="email" label="Email" placeholder="Email" v-model="invite.email"
          :validations="{required:true, email:true}" />
        <dynamic-input name="firstname" label="First name" placeholder="First name" v-model="invite.firstname"
          :validations="{required:true}" />
        <dynamic-input name="lastname" label="Last name" placeholder="Last name" v-model="invite.lastname"
          :validations="{required:true}" />
        <dynamic-input name="customerReference" :label="$store.getters.appRefLabel"
          :placeholder="$store.getters.appRefLabel" v-model="invite.customerReference"
          :validations="{required:false}" />
        <dynamic-input name="templateId" label="Application" v-model="invite.templateId" 
          v-show="templateList.length > 1" type="SELECT" :applicationOptions="applicationOptions"
          :validations="{required:true}"/>
        <button @click.prevent="sendInvite" class="btn btn-fill btn-default pull-right"
          v-bind:disabled="$validator.errors.any()" v-bind:class="{'btn-disabled': $validator.errors.any()}"><i
            class="fa fa-paper-plane"></i>&nbsp;Invite</button>
      </div>
    </div>
    <div key="History" class="col-md-12 card">
      <div class="card-header">
        <div style="display: flex; justify-content: space-between">
          <h4 class="card-title">Applicant History</h4>
          <div v-if="this.$store.state.applicantCheckboxArchive" class="pull-right">
            <button class="btn btn-fill btn-default" @click="deselectArchived"><i class="fa fa-times"></i>Cancel</button>
            <button v-if="this.$store.state.applicantSelectedRows.length == 0" class="btn btn-fill btn-default disabled"><i
                class="fa fa-archive"></i>Archive
              Selected</button>
            <button v-else class="btn btn-fill btn-default" @click="archiveModal()"><i
                class="fa fa-folder-open-o"></i>Archive Selected
              ({{$store.state.applicantSelectedRows.length}})</button>
          </div>
          <button class="btn btn-fill btn-default" @click="toggleCheckboxCol" v-else><i class="fa fa-archive"></i>Group
            Archive</button>
        </div>
      </div>
          
      <div class="card-content row form-horizontal">
        <div class="filters form-group" style="margin-left: 0">
          <transition name="el-fade-in-linear" mode="out-in">
            <div key="filtersClose" v-if="!filtersOpen">
              <div class="col-sm-10">
                <el-input placeholder="Quick Search" prefix-icon="el-icon-search" v-model="query" :clearable="true"
                  style="width: 100% !important"></el-input>
              </div>
              <div class="col-sm-2">
                  <button @click.prevent="filtersOpen = true" class="btn btn-fill btn-default pull-right"><i
                      class="fa fa-filter"></i>&nbsp;Filters {{filtersCount}}</button>
              </div>
            </div>
            <div key="filtersOpen" v-else="filtersOpen" class="col-sm-12 card-plain">
              <div class="el-collapse">
                <div class="el-collapse-item is-active">
                  <div role="tab" style="margin-bottom: 15px">
                    <div @click="filtersOpen= false" role="button" class="el-collapse-item__header pull-right">
                      <i class="fa fa-times pull-right"></i>
                    </div>
                  </div>
                  <div role="tabpanel" class="el-collapse-item__wrap">
                    <div class="el-collapse-item__content">
                      <div class="form-horizontal">
                        <div class="form-group">
                          <label v-if="isIndividual" class="col-sm-2 control-label">Organisation</label>
                          <label v-else class="col-sm-2 control-label">Applicant</label>
                          <div class="col-sm-10">
                            <el-input placeholder="All" prefix-icon="el-icon-search" v-model="query" :clearable="true">
                            </el-input>
                            <span v-if="isIndividual" class="help-block">The company or university an application is in
                              submission to.</span>
                            <span v-else class="help-block">The individual submitting the application to your
                              organisation.</span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Status</label>
                          <div class="col-sm-10">
                            <el-select multiple v-model="status" :clearable="true" placeholder="All">
                              <el-option v-if="isIndividual" value="OPEN" label="Open" />
                              <el-option value="PENDING" label="Pending" />
                              <el-option value="COMPLETED" label="Completed" />
                              <el-option v-if="!isIndividual" value="ARCHIVED" label="Archived" />
                            </el-select>
                            <span class="help-block">Select multiple status' or <a @click.prevent="clearResults"
                                href="#">clear</a> for all status'.</span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Created Date</label>
                          <div class="col-sm-10">
                            <el-date-picker v-model="dateRange" type="daterange" size="large" :editable="false"
                              start-placeholder="Start date" end-placeholder="End date" value-format="yyyy-MM-dd"
                              :default-value="defaultDate" :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="help-block">Show only applications created on or between these dates.</span>
                          </div>
                        </div>

                        <div v-if="templateList.length > 1" class="form-group">
                          <label class="col-sm-2 control-label">Application</label>
                          <div class="col-sm-10">
                            <el-select v-model="selectedTemplateId" @change="handleApplicationTemplateChange">
                              <el-option key="All" label="All" value="All" />
                              <el-option  v-for="template in templateList" 
                                          :key="template.id"
                                          :label="template.status === 'CLOSED' ? `CLOSED - ${template.name}` : template.name"
                                          :value="template.id"
                                          />
                            </el-select>
                            <span class="help-block">Select an application to see its specific filters or <a @click.prevent="clearResults"
                                href="#">clear</a> for all applicants.</span>
                          </div>
                        </div>

                        <div v-if="!isIndividual" v-for="filter in customFilters" class="form-group">
                          <div v-if="filter.type == 'TEXT'">
                            <label class="col-sm-2 control-label">{{filter.name}}</label>
                            <div class="col-sm-10">
                              <el-select v-if="filter.refData == 'ONLY'" :name="filter.key" placeholder="All" filterable
                                prefix-icon="el-icon-search" :allow-create="false" :clearable="true"
                                v-model="filter.value" @input="customerFilterChanged">
                                <el-option-group>
                                  <el-option v-for="item in filter.values" :key="item" :label="item" :value="item">
                                  </el-option>
                                </el-option-group>
                              </el-select>
                              <el-input v-else @input="customerFilterChanged" placeholder="All"
                                prefix-icon="el-icon-search" v-model="filter.value" :clearable="true"></el-input>
                            </div>
                          </div>
                        </div>

                        <div v-if="!isIndividual" class="form-group">
                          <label class="col-sm-2 control-label">{{$store.getters.appRefLabel}}</label>
                          <div class="col-sm-10">
                            <el-input placeholder="All" prefix-icon="el-icon-search" v-model="customerReference"
                              :clearable="true"></el-input>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label"></label>
                          <div class="col-sm-10">
                            <button @click.prevent="clearFilters" class="btn btn-default btn-fill btn-wd">Clear All</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="card-header">
          <h4 class="card-title">{{selectedTemplateName}}</h4>
        </div>
        <application-history-table 
              :query="query" :dateRange="dateRange" 
              :customFilters="customFilters" 
              :status="status"
              :customerReference="customerReference" 
              :templateId="selectedTemplateId"
        />
      </div>
    </div>

  </div>
</template>
<script>
import ApplicationHistoryTable from 'src/views/Applications/components/ApplicationHistoryTable'
import DynamicInput from 'src/views/Verifications/components/DynamicInput'

import { DatePicker } from 'element-ui'
import ModalApplicantArchive from 'src/components/ModalPlugin/ModalApplicantArchive'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: "application-history",
  components: {
    [DatePicker.name]: DatePicker,
    DynamicInput,
    'application-history-table': ApplicationHistoryTable
  },
  data() {
    return {
      inviting: false,
      invite: {
        email: null,
        firstname: null,
        lastname: null,
        customerReference: null,
        templateId: null
      },
      query: "",
      status: [],
      dateRange: [],
      selectedTemplateId: "All",
      templateList: [],
      customFilters: [],
      customerReference: null,
      filtersOpen: false,
      pickerOptions: {
        disabledDate(date) {
          return date > new Date()
        },
        shortcuts: [
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.$api.getApplicationTemplateIds()
      .then(response => {
        this.templateList = response.data
        if(response.data.length == 1) {
          this.selectedTemplateId = this.templateList[0].id
          this.invite.templateId = this.templateList[0].id
          this.handleApplicationTemplateChange()
        }
      })
    if (this.$route.query.status && this.$route.query.status != 'ALL') {
      this.status = []
      this.status.push(this.$route.query.status)
    } else {
      this.status = (this.isIndividual ? [] : ["PENDING", "COMPLETED"])
    }
  },
  activated() {
    if (this.$route.query.status && this.$route.query.status != 'ALL') {
      this.status = []
      this.status.push(this.$route.query.status)
    }
  },
  beforeDestroy() {
    this.$store.state.applicantCheckboxArchive = false
  },
  watch: {
    dateRange(value) {
      if (value == null) {
        this.dateRange = []
      }
    },
    query(value) {
      if(value && !this.filtersOpen && !this.isIndividual) {
        this.status = ["PENDING", "COMPLETED", "ARCHIVED"]
      } else if(!value && !this.filtersOpen && !this.isIndividual) {
        this.status = ["PENDING", "COMPLETED"]
      }
    }
  },
  computed: {
    selectedTemplateName() {
      if (this.selectedTemplateId === 'All' || this.templateList.length == 1) return 'All Applicants';
      const template = this.templateList.find(
        (t) => t.id === this.selectedTemplateId
      );
      return template ? `${template.name} Applicants` : 'All Applicants';
    },
    isIndividual() {
      return this.$store.state.isIndividual
    },
    filtersCount() {
      var count = 0
      if (this.query) count++
      if (this.dateRange.length > 0) count++
      if (this.status.length > 0) count++
      if (this.customFilters && this.customFilters.length > 0) {
        this.customFilters.forEach(filter => {
          if (filter.value != null) {
            count++
          }
        })
      }
      return count > 0 ? "(" + count + ")" : ""
    },
    defaultDate() {
      return moment().subtract(1, 'months').format('YYYY-MM-DD');
    },
    applicationOptions() {
      return this.templateList
        .filter(t => t.status !== 'CLOSED')
        .map(t => ({
          value: t.id,
          label: t.name
        }))
    }
  },
  methods: {
    handleApplicationTemplateChange() {
      if(this.selectedTemplateId == "All") {
        this.customFilters = []
        return
      }
      const templateId = this.selectedTemplateId
      this.$api.getApplicationFiltersByTemplate(templateId)
        .then(response => {
          this.customFilters = response.data
        })
        .catch((error) => {
        console.error('Error fetching template filters:', error);
      });
    },
    toggleCheckboxCol() {
      this.$store.state.applicantCheckboxArchive = !this.$store.state.applicantCheckboxArchive
    },
    sendInvite() {
      //Needed as the templateId validation isnt attached as the values are dynamic
      if(this.invite.email === null
        || this.invite.firstname === null
        || this.invite.lastname === null
        || this.invite.templateId === null
      ) {
        this.$snotify.error("Please fill all mandatory fields first.", "Validation Error");
        return;
      }
      this.inviting = true
      this.$api.postRegisterApplicant(this.invite)
        .then(response => {
          this.inviting = false
          this.$snotify.success("Applicant invitation sent.", "Success")
          this.invite = {
            email: null,
            firstname: null,
            lastname: null,
            customerReference: null,
            templateId: null
          }
          //So the templateId doesnt show the no input error on success
          this.$validator.reset('fields' + this.validationScope);
        })
        .catch(error => {
          this.inviting = false
          this.$snotify.error("Applicant invation NOT sent, please try again or contact support.", "Error", {
            timeout: 7500
          })
        })
    },
    customerFilterChanged:
      _.debounce(function () {
        var oldQuery = this.query
        this.query = this.query + " "
        setTimeout(() => {
          this.query = oldQuery
        }, 50)
      }, 200),
    filtersChange(activeNames) {
      var _this = this;
      setTimeout(function () {
        _this.filtersOpen = activeNames.includes("open")
      }, 0);
    },
    clearResults() {
      this.status = []
      this.selectedTemplateId = "All"
      //this.$store.commit('setHistoryFilters', {results: []})
    },
    clearFilters() {
      this.query = ""
      this.status = []
      this.selectedTemplateId = "All"
      this.dateRange = []
      this.customerReference = null
      if (this.customFilters && this.customFilters.length > 0) {
        this.customFilters.forEach(filter => {
          filter.value = null
        })
      }
      //this.$store.commit('clearHistoryFilters', null)
    },
    archiveModal() {
      this.$modal.show(ModalApplicantArchive,
        {
          nameInit: this.query,
          countryInit: this.region ? this.region.name : null
        })
    },
    deselectArchived() {
      this.$store.state.applicantSelectedRows = [];
      this.toggleCheckboxCol();
    }
  }
}
</script>
<style>

</style>
